import React, {Component} from 'react';
import axios from 'axios/index';
import {ListButton} from 'admin-on-rest';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import CreateReportJobForm from '../components/CreateReportJobForm';
import {RESOURCES as jobResources} from '../fuseReportsResourceMap';
import {getPostHeaders} from '../shared/serverFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import {viewStyles} from '../shared/styles-view';
import Avatar from 'material-ui/Avatar';
import {Card, CardActions, CardText} from 'material-ui/Card';
import Icon from 'material-ui/svg-icons/action/work';

export const fuseCreateReportJobIcon = Icon;

/**
 * Page with Report Jobs table and form to create a Report Job (DEPRECATED)
 *
 */
export class CreateReportJob extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: null,
            selectedReportType: null,
            submitted: false,
            submitting: false,
            success: false
        };
    }

    handleFormSubmit = (data) => {
        this.setState({
            submitted: false,
            submitting: true
        }, () => {

            const tokenStatus = checkTokenStatus(null);
            if (tokenStatus.expired) {
                return;
            }

            const resource = jobResources.ReportJobs.CREATE(data);
            axios({
                method: resource.method,
                url: resource.uri,
                data: data,
                headers: getPostHeaders()
            }).then((result) => {
                if (result && result.data && result.data.payload) {
                    this.processSubmission(result);
                } else {
                    this.processSubmission(null);
                }
            }).catch((error) => {
                if (error.response) {
                    // Server response outside 2xx
                    console.log(error.response.data);
                    error = error.response.data;
                } else if (error.request) {
                    // No response
                    console.log(error.request);
                    error = error.request;
                } else {
                    console.log('Schedule Report Error', error.message);
                }
                this.processSubmission(null);
            });
        });
    };

    processSubmission = (data) => {
        let success = !!(data);
        this.setState({
            submitted: true,
            submitting: false,
            success: success
        });
    };

    render() {
        const {
            submitted,
            submitting,
            success
        } = this.state;

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>Create A Report Job</span>;

        return (
            <div className="lists-container">
                <Card>
                    <CardActions style={viewStyles.actions}>
                        <ListButton basePath="/ReportJobs"/>
                    </CardActions>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <span className="list-description hide-print">
                            <p>Create a Report Job by selecting a Report Type and completing the options below.</p>
                        </span>
                        <CreateReportJobForm
                            submitted={submitted}
                            submitting={submitting}
                            success={success}
                            onFormComplete={(e) => this.handleFormSubmit(e)}
                        />
                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/views/CreateReportJob.js